import { WrenchIcon } from 'lucide-react'

import { registerSplitViewContent } from '../split-view.registry'

import { ToolCallContentContainer } from './tool-call-content.container'
import type { ToolCallContentData } from './tool-call-content.interface'

const isToolCallContentData = (data: unknown): data is ToolCallContentData =>
  typeof data === 'object' &&
  data !== null &&
  'toolCall' in data &&
  typeof (data as ToolCallContentData).toolCall === 'object' &&
  (data as ToolCallContentData).toolCall !== null &&
  'id' in (data as ToolCallContentData).toolCall &&
  'type' in (data as ToolCallContentData).toolCall &&
  (data as ToolCallContentData).toolCall.type === 'tool-call'

export const registerToolCallContent = (): void => {
  registerSplitViewContent<ToolCallContentData>({
    type: 'tool-call',
    title: 'Tool Result',
    subtitle: (data) => data.toolCall.friendlyName ?? data.toolCall.toolName,
    icon: WrenchIcon,
    component: ToolCallContentContainer,
    isValidData: isToolCallContentData,
  })
}
